exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content[data-v-4e77d56d]{width:800px;margin:50px auto 0}.stepFour-content[data-v-4e77d56d]{width:360px;margin:50px auto 0;text-align:center}.stepFour-content i[data-v-4e77d56d]{font-size:40px;color:#19be6b}.stepFour-content p[data-v-4e77d56d]{margin-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4e77d56d&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/pc/stepFour.vue
// module id = 160
// module chunks = 0